// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamGetBody = {
  teamId: string;
};

export type typeTeamGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    team: {
      teamId: string;
      sportId: string;
      leagueId: string;
      teamKey: string;
      name: string;
      marketName: string;
      nickname: string;
      abbreviation: string;
      primaryColorHex?: string | null;
      secondaryColorHex?: string | null;
      venueId?: string | null;
      isActive: boolean;
      logoUrl?: string | null;
    };
    league: {
      leagueId: string;
      leagueKey: string;
      name: string;
      shortName: string;
      abbreviation: string;
      logoUrl?: string | null;
    };
    venue?: {
      venueId: string;
      name: string;
      city?: string | null;
      stateCode?: string | null;
      countryCode?: string | null;
      timeZone?: string | null;
      capacity?: number | null;
      isIndoor?: boolean | null;
    } | null;
  };
};

export type typeTeamGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamGetBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamGetBody);
  }

  return async function postTeamGet(
    payload: typeTeamGetBody,
  ): Promise<typeTeamGetOutput200 | typeTeamGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamGet" failed before calling the network. #d391354b1335`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d391354b1335" },
        },
        data: null,
      } as typeTeamGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team/get`,
      httpMethod: "POST",
      options,
    })) as typeTeamGetOutput200 | typeTeamGetOutput400;
  };
}
